import { invokeFunction, ApiError } from "@/lib/api";
import type { TrackingResult } from "./types";
import { mockTracking } from "./mock";

/**
 * Public tracking lookup. Calls the `track` edge function, which holds the
 * Samsara/QuickManage secrets server-side and returns ONLY the minimal,
 * sanitized data an anonymous user should see (docs/SECURITY.md sec 4).
 *
 * Falls back to mock data when the backend is not configured yet, so the UI is
 * fully reviewable during Phase 0-2.
 */
export async function lookupTracking(reference: string): Promise<TrackingResult> {
  try {
    return await invokeFunction<TrackingResult>("track", { reference });
  } catch (err) {
    if (err instanceof ApiError && err.status === 503) {
      return mockTracking(reference);
    }
    throw err;
  }
}
